module.exports = __webpack_public_path__ + "static/media/heroku.9291bd09.svg";